import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Paper, ListItem, ListItemAvatar, Avatar, ListItemText } from '@mui/material';
import { reportIDsSelector } from '../../features/datacenter/historySlice';
import TrackListItem from './TrackListItem';

const TrackListView = () => {
    const reportIDs = useSelector(reportIDsSelector);
    const trackItems = () => {
        return reportIDs.map(t => <TrackListItem key={t} reportID={t} />);
    }
    useEffect(() => {
        //console.log("Track list view", reportIDs);
    }, [reportIDs])
    return (
        <div>
            <Paper elevation={3}>
                {
                    reportIDs.length === 0 ?
                        <ListItem key="noevent">
                            <ListItemAvatar>
                                <Avatar style={{ backgroundColor: 'Red' }}>
                                    0
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="No saved tracks found" />
                        </ListItem>
                        :
                        trackItems()
                }
            </Paper>
        </div>
    );
}

export default TrackListView;